
export class EventRequestAutocomplete {
  requestNo: string;
  eventTitle: string;
}



// WEBPACK FOOTER //
// ./src/app/core/models/event-request-autocomplete.ts